import React, { FC } from 'react';
import FormContainer from 'src/components/FormContainer';
import { HippocratesContentHome } from 'src/api/types';
import { getHippocratesContentProjects, patchHippocratesContentProjects } from 'src/api';
import fieldsConfig from './fieldsConfig';

const filterSavePayload = (values: HippocratesContentHome) => {
  const res = { ...values };

  ['banner', 'first_logo', 'second_logo'].forEach(field => {
    if (typeof res?.[field] === 'string') {
      delete res[field];
    }
  });

  return res;
};

type Props = unknown;

const ProjectPage: FC<Props> = () => {
  return (
    <FormContainer
      config={fieldsConfig}
      getContent={getHippocratesContentProjects}
      saveContent={patchHippocratesContentProjects}
      filterSavePayload={filterSavePayload}
    />
  );
};

export default ProjectPage;
